<!-- eslint-disable vue/return-in-computed-property -->
<template>
    <vx-card class="mb-base">
        <div class="item mb-3" v-if="studyPlan.faculty&&!this.GET_SCHEDULE.use_schedule">
            <label class="text-primary font-medium">{{$t('faculty')}}:</label>
            <div class="val">
                {{studyPlan.faculty}}
            </div>
        </div>
        <div class="item mb-3" v-if="studyPlan.cathedra">
            <label class="text-primary font-medium">{{!this.GET_SCHEDULE.use_schedule? $t('cathedra') : $t('department')}}:</label>
            <div class="val">
                {{studyPlan.cathedra}}
            </div>
        </div>
        <div class="item mb-3" v-if="studyPlan.speciality">
            <label class="text-primary font-medium">{{$t('direction')}}:</label>
            <div class="val">
                {{studyPlan.speciality}}
            </div>
        </div>
        <div class="item mb-3" v-if="studyPlan.education_program.code && studyPlan.education_program.name">
            <label class="text-primary font-medium">{{!this.GET_SCHEDULE.use_schedule ? $t('educational_program') : $t('direction')}}</label>
            <div class="val">
                {{studyPlan.education_program.code}} - {{studyPlan.education_program.name}}
            </div>
        </div>
        <vs-button v-if="id_edit" class="w-full" color="primary" :to="{name: 'editMyProfile'}" type="border">{{$t('user-settings')}}</vs-button>
        <vs-button else class="w-full" color="primary" :disabled="active" :to="{name: 'chat', query: {user: this.advisors }}" type="border">{{$t('write_a_message')}}</vs-button>
    </vx-card>
</template>

<script>
import { mapGetters } from "vuex";

export default {
    props: {
        studyPlan: {
            type: Object,
            required: true
        },
        id_edit:{
            type: Boolean,
            default:false,
            required: false
        },
    },
    computed: {
        ...mapGetters({
            GET_SCHEDULE: 'system_settings/GET_SCHEDULE'
        }),
        advisors() {
            if(this.$store.state.user.user.supervisors.uid) return this.$store.state.user.user.supervisors.uid
        },
        active() {
            if(this.$store.state.user.user.supervisors.uid) return false
            else return true
        }
    }
}
</script>
